import {Link} from '@remix-run/react'
import {Container} from './container.tsx'
import {FooterNavLinks} from './footer-nav-links.tsx'

export function Footer() {
    return (
        <footer className="border-t border-gray-200">
            <Container>
                <div className="flex flex-col items-start justify-between gap-y-12 pt-16 pb-6 lg:flex-row lg:items-center lg:py-16">
                    <div>
                        <div className="flex items-center text-gray-900">
                            <div>
                                <div>
                                    <img className="block h-6 w-auto"
                                         src="/img/logo/logo-black.png" alt="refundr"/>
                                </div>
                                <p className="mt-1 text-sm">Tax return and client management digital solutions.</p>
                            </div>
                        </div>
                        <nav className="mt-11 flex gap-8">
                            <FooterNavLinks/>
                        </nav>
                    </div>
                    <div className="group relative -mx-4 flex items-center self-stretch p-4 transition-colors hover:bg-gray-100 sm:self-auto sm:rounded-2xl lg:mx-0 lg:self-auto lg:p-6">
                        <div className="relative flex h-24 w-24 flex-none items-center justify-center">
                            <div className="order-first text-3xl font-semibold tracking-tight text-gray-900">6000+</div>
                        </div>
                        <div className="ml-8 lg:w-64">
                            <p className="text-base font-semibold text-gray-900">
                                <Link to="#">
                                    <span className="absolute inset-0 sm:rounded-2xl"/>
                                    returns processed and counting
                                </Link>
                            </p>
                            <p className="mt-1 text-sm text-gray-700">
                                Established, proven processes, recognized by tax professionals.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center border-t border-gray-200 pt-8 pb-12 md:flex-row-reverse md:justify-between md:pt-6">
                    <p className="mt-6 text-sm text-gray-500 md:mt-0">
                        &copy; Copyright {new Date().getFullYear()}. All rights reserved.
                    </p>
                </div>
            </Container>
        </footer>
    )
}
